import { useMemo } from 'react'

import { useCallManager } from '../../../contexts/call_manager_context'
import { CS } from '../call_manager/connection_status_reducer'

export const useCallConnectionMessage = () => {
  const {
    activeCall: { callRecord, connectionStatus },
  } = useCallManager()

  return useMemo(() => {
    switch (connectionStatus) {
      case CS.DISCONNECTED:
        return 'Incoming call'
      case CS.JOINING:
        if (callRecord?.room_sid) {
          return 'Connecting...'
        } else {
          return 'Joining...'
        }
      case CS.CALL_CONNECTED:
        return 'Waiting for others'
      case CS.ROOM_CONNECTED:
        return 'Connected'
      case CS.ROOM_RECONNECTING:
        return 'Reconnecting...'
      case CS.LEAVING_CALL:
        return 'Leaving...'
      case CS.JOIN_ROOM_ERROR:
        return 'Connection failed'
    }
  }, [callRecord?.room_sid, connectionStatus])
}
